import { personRecord } from "@/components/MacOsPermissions/person-record";

/**
 * How long a switched-off capture is remembered. A day, matching the refusal record: long enough to
 * cover the relaunches of one onboarding, short enough that it cannot decide a later one.
 */
const PAUSE_TTL_MS = 24 * 60 * 60 * 1000;

const record = personRecord<true>(
  "aiCapturePaused",
  PAUSE_TTL_MS,
  (value): value is true => value === true
);

/**
 * Whether this hire has switched capture off.
 *
 * Persisted, so a refresh does not quietly start recording again, and keyed by person with a TTL
 * because laptops are handed on. Not a consent answer and never to be read as one.
 *
 * A storage failure reads as not paused -- the same answer a hire who never pressed Stop gets.
 */
export const isCapturePaused = (personId: string | undefined): boolean =>
  record.read(personId) === true;

/** Records the choice. A failed write leaves capture running rather than throwing at the hire. */
export const setCapturePaused = (
  personId: string | undefined,
  isPaused: boolean
): void => {
  if (isPaused) {
    record.write(personId, true);
    return;
  }
  record.clear();
};
